const convertNumberToTimeAMPM = (timeNumber) => {
  const timeStr = timeNumber.toString().padStart(4, "0"); // Ensure 4-digit format (e.g., "0930")
  let hours = parseInt(timeStr.slice(0, 2), 10); // Extract hours
  const minutes = timeStr.slice(2, 4); // Extract minutes

  const period = hours >= 12 ? "PM" : "AM"; // Determine AM/PM
  hours = hours % 12 || 12; // Convert 24-hour to 12-hour format (0 becomes 12)

  return `${hours}:${minutes} ${period}`;
};
function convertToTime(number) {
  let str = number.toString().padStart(4, "0"); // Ensure it's 4 digits
  return `${str.slice(0, 2)}:${str.slice(2)}`;
}

module.exports = {
  convertNumberToTimeAMPM,
  convertToTime,
};
